module.exports = __webpack_public_path__ + "media/svg/ly-5b82a613.svg";